/* live events over /ws/events: refresh / toast / job_log / job_status */
import { createStore, load, toast, wsUrl } from "./store";

type LogLine = [string | null, string];
const jobSubs = new Set<(job: string, lines: LogLine[]) => void>();
/* the job page subscribes to streamed log lines */
export function onJobLog(f: (job: string, lines: LogLine[]) => void) { jobSubs.add(f); return () => { jobSubs.delete(f); }; }

export const wsUp = createStore(true);
let ws: WebSocket | null = null, tries = 0;
export function connectLive() {
  if (ws) return;
  const open = () => {
    const s = (ws = new WebSocket(wsUrl("/ws/events")));
    s.onopen = () => { if (tries) load().catch(() => {}); tries = 0; wsUp.set(true); };
    s.onclose = () => { wsUp.set(false); setTimeout(open, Math.min(15000, 1000 * ++tries)); };
    s.onmessage = (ev) => {
      const m = JSON.parse(ev.data);
      if (m.type === "refresh") load().catch(() => {});
      else if (m.type === "toast") toast(m.msg, m.sub, m.kind);
      else if (m.type === "job_log") jobSubs.forEach((f) => f(m.job, m.lines));
      else if (m.type === "job_status") load().catch(() => {});
    };
  };
  open();
}
